import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { Navigate } from 'react-router-dom';
import { UPTIME_TAB_FEATURE_FLAG } from '../../featureFlags/uptime';
import { UptimePage } from './UptimePage';

/** Renders the uptime page only when the user has enabled the profile feature flag. */
export function UptimeRoute() {
  const featureFlags = useApi(featureFlagsApiRef);

  if (!featureFlags.isActive(UPTIME_TAB_FEATURE_FLAG)) {
    return <Navigate to="/catalog" replace />;
  }

  return <UptimePage />;
}
